var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"line"}),_c('AttendeeList',{attrs:{"list":_vm.list,"meetId":_vm.meetId,"meetStatus":_vm.meetInfo.meetStatus,"applyField":_vm.applyField,"ifDelete":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }